import * as React from 'react'

// Active-row state for arrow-key navigation, keeping the highlighted row
// scrolled into view. `count` is the number of navigable rows on screen.
export const useSearchKeyboardNav = (count: number) => {
    const [activeIndex, setActiveIndex] = React.useState(0)
    const rowRefs = React.useRef<(HTMLDivElement | null)[]>([])

    React.useEffect(() => {
        rowRefs.current[activeIndex]?.scrollIntoView({ block: 'nearest' })
    }, [activeIndex])

    const onArrowKeyDown = (event: React.KeyboardEvent): boolean => {
        if (event.key === 'ArrowDown') {
            event.preventDefault()
            setActiveIndex((index) => Math.min(index + 1, Math.max(count - 1, 0)))
            return true
        }
        if (event.key === 'ArrowUp') {
            event.preventDefault()
            setActiveIndex((index) => Math.max(index - 1, 0))
            return true
        }
        return false
    }

    return { activeIndex, setActiveIndex, rowRefs, onArrowKeyDown }
}
